'use client'

import { ReactNode } from 'react'
import { Dialog as VintedModal, Button, Divider } from '@vinted/web-ui'

import { MAX_FACETED_ITEMS_COUNT } from 'pages/Catalog/constants'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useCatalogContext } from 'pages/Catalog/CatalogProvider'

type Props = {
  isOpen: boolean
  children?: ReactNode
  hideSubmitButton?: boolean
  testId?: string
  totalItemsCount?: number | null
  renderNavigation?: () => ReactNode
  onSubmit?: () => void
}

const FilterModal = ({
  isOpen,
  children,
  hideSubmitButton = false,
  testId,
  totalItemsCount,
  renderNavigation,
  onSubmit,
}: Props) => {
  const translate = useTranslate('catalog.filters.mobile')
  const {
    state: {
      dynamicFilters: { filterFacetsCountMax },
    },
  } = useCatalogContext()

  const baseText = translate('filters_screen.actions.show_results')
  const totalFactedItemsCount = filterFacetsCountMax || MAX_FACETED_ITEMS_COUNT
  let submitButtonText = baseText

  if (totalItemsCount === null || totalItemsCount === undefined) {
    submitButtonText = baseText
  } else if (totalItemsCount >= totalFactedItemsCount) {
    submitButtonText = `${baseText} (${totalFactedItemsCount}+)`
  } else {
    submitButtonText = `${baseText} (${totalItemsCount})`
  }

  return (
    <VintedModal
      show={isOpen}
      className="u-fill-width u-fill-height u-flexbox u-flex-direction-column"
      isModal={false}
      testId={testId}
    >
      {renderNavigation && (
        <div className="u-flex-shrink-none">
          {renderNavigation()}
          <Divider />
        </div>
      )}
      <div className="u-overflow-auto u-fill-height">{children}</div>
      {!hideSubmitButton && (
        <div className="u-ui-padding-large u-margin-top-auto">
          <Button
            text={submitButtonText}
            onClick={onSubmit}
            theme="primary"
            styling={Button.Styling.Filled}
          />
        </div>
      )}
    </VintedModal>
  )
}

export default FilterModal
